<template>

  <bar-chart style="width: 100%; height: 250px"
             :class="loading ? 'loading':''"
             :chartData="getChartData"
             :options="getOptions"/>
</template>

<script>
import BarChart from '@/components/insights/charts/barChart.js'
import {mapGetters} from "vuex";
import timeCalc from "@/mixins/timeCalc";
import generalMethods from "@/mixins/insights/generalMethods";
import chartColors from "@/mixins/insights/chartColors";
import downTimesOee from "@/mixins/oeeAnalytics/downTimes"
import colours from "@/mixins/oeeAnalytics/colours";

export default {
  components: {
    BarChart,
  },
  mixins: [timeCalc, generalMethods, chartColors, downTimesOee,colours],
  props: ['downTimes', 'uniqueReasons'],
  data() {
    return {
      loading: false,
      config: {}
    }
  },
  computed: {
    ...mapGetters('users', ['getClaims']),
    getOptions() {
      let filteredOnReason = this.uniqueReasons.length == 1
      const self = this
      return {
        legend: {
          display: false,
        },
        animation: {
          duration: 0 // general animation time
        },
        hover: {
          animationDuration: 100,
          intersect:false,// duration of animations when hovering an item
        },
        layout: {
          padding: {
            left: 5,
            right: 5,
            top: 5,
            bottom: 0
          }
        },
        title: {
          display: true,
          text: self.$t('oeeAnalytics.downTimes.trend.chartTitle'),
          fontSize: 20,
          fontStyle: 'normal',
          position: 'top',
          padding: 40
        },
        scales: {
          xAxes: [
            {

              distribution: 'series',
              gridLines: {
                display: false
              },
              stacked: true,
              offset: true, // IF this i
              type: 'time',
              time: {
                unit: filteredOnReason ? 'seconds' : 'day',
                round: 'milliseconds',
                displayFormats: {
                  minute: 'D/MM HH:mm',
                  day: 'DD/MM',
                  seconds: 'DD/MM HH:mm:ss'
                }
              }
            },

          ],
          yAxes: [
            {
              id: 'time',
              gridLines: {
                display: true
              },
              ticks: {
                beginAtZero: true,
                autoSkip: true,
                spanGaps: true,
                maxTicksLimit: 10,
                stepSize: ((1000 * 60)) * 2,
                callback: function (label, index, labels) {
                  return self.getHoursFromMilliseconds(label, false) + ' hours'
                }
              }
            },
            {
              id: 'norm',
              position: 'right',
              gridLines: {
                display: false,
              },
              ticks: {
                display: false,
                beginAtZero: false,

              }
            }
          ],
        },
        //This will show money in tooltip with format of $xx.xx
        tooltips: {
          callbacks: {
            title: function (tooltip) {
              return moment(tooltip[0].label).format(filteredOnReason ? 'MM/DD HH:mm:ss' : 'MMM DD')
            },
            label: function (tooltipItem) {
              return self.formattedColonTime(tooltipItem.yLabel)    //tooltipItem.value
            }
          }
        },
        plugins: {
          datalabels: {
            color: 'black',
            anchor: 'end',
            align: 'end',
            font: {
              // weight: 'bold',
              size: 15
            },
            offset: 5,
            rotation: -45,
            display: function (ctx) {
              return false
              if (ctx.datasetIndex === 1 || ctx.dataset.data.length > 50) {
                return false
              }
              return true //ctx.datasetIndex >   0 //ctx.chart.$totalizer.utmost;
            },
            formatter: (value, ctx) => {


              if (ctx.datasetIndex == 0) {
                if (filteredOnReason) {
                  return self.formattedColonTime(value.y, true)

                } else {

                  return self.getMinutesFromMilliseconds(value.y, false) + ' ' + self.$tc('ui.date.hour', value).toLowerCase()
                }
              }
            },
          }
        },
        responsive: true,
        maintainAspectRatio: false
      }
    },

    calculatedTarget() {
      let norm = []
      let data = _.chain(this.getDownTimesGroupped).map((dt, id) => ({
        t: id,
        y: _.sumBy(dt, d => {
          return moment(d.downTimeEnded).diff(d.downTimeStart)
        }),
      })).value()
      if (this.uniqueReasons.length == 1) {

        data = _.chain(this.getDownTimes).map((dt, id) => ({
          t: new Date(dt.downTimeStart),
          y: moment(dt.downTimeEnded).diff(dt.downTimeStart)
        })).value()
        // test data for duplicates
        let updatedData = [];
        let tempDateCollection = [];
        data.map((yData, index) => {

          const formatedDate = moment(yData.t).format('DD/MM/YYYY HH:mm:ss');

          if (tempDateCollection.includes(formatedDate)) {
            const index = tempDateCollection.indexOf(formatedDate);
            const element = updatedData[index];
            updatedData[index] = {...element, y: element.y + yData.y}
          } else {
            tempDateCollection.push(formatedDate);
            updatedData.push(yData);
          }
          data = updatedData
        })
        norm = _.chain(this.getDownTimes).map((dt, id) => ({
          t: new Date(dt.downTimeStart),
          y: dt.normInMs
        })).value()

      }
      const count = _.chain(this.getDownTimesGroupped).map((dt, id) => ({
        t: id,
        y: 1
      })).value()

      return [data, count, norm]

    },
    getDownTimes() {
      let downTimes = this.downTimes
      if (this.config.filterByValue) {
        return this.getFilteredDownTimes
      }
      return downTimes
    },
    getDownTimesPerWorkflow() {

    },
    getDownTimesGroupped() {
      let filtered = _.filter(this.downTimes, dt => {
        if (dt.reason) {
          if (this.config.filterReason) {
            return this.config.filterReason === this.joinReasonsToString(dt)
          } else {
            return dt
          }
        }
      })


      return _.groupBy(filtered, (dt) => {
        return moment(dt.downTimeStart).startOf('day').toDate()
      })
    },
    getChartData() {
      let datasets = {
        labels: [],
        datasets: [
          {
            type: 'bar',
            order: 1,
            yAxisID: 'time',
            label: this.$root.$t('insights.ui.duration'),
            backgroundColor: this.getOeeColours('availability'), //'#DD872E', //this.colors.downTimes.reasons,
            data: this.calculatedTarget[0],

          },
          // {
          //   yAxisID: 'count',
          //   label: 'Aantal',
          //   backgroundColor: 'grey',
          //   data: this.calculatedTarget[1]
          // },
        ]
      }

      if (this.uniqueReasons.length == 1) {
        let norm = this.downTimes[0].normInMs
        if (norm > 0) {
          // norm = norm / 1000 / 60 /60 // INS hours
          datasets.datasets.push({
            type: 'line',
            yAxisID: 'norm',
            label: 'Norm',
            fill: false,
            tension: 0,
            order: 0,
            backgroundColor: '#565656',
            borderColor: '#565656',
            pointRadius: 0,             // data: new Array(this.calculatedTarget[0].length).fill(norm)
            data: this.calculatedTarget[2]

          })
          console.log(this.calculatedTarget[2])
        }
      }

      return datasets
    }
  },
  methods: {},
  watch: {},
  created() {
  }
}
</script>

<style scoped lang="scss">
.chart-container {
  height: calc(100%)
}


.fa-chevron-square-left, .fa-chevron-square-right {
  font-size: 3rem;
  font-weight: 300;
  line-height: 1.5;
  cursor: pointer;
}

@media only screen and (max-width: 800px) {
  .chart-container {
    height: calc(100% - 10rem)
  }
}
</style>
